import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/functions'



// firebase init
// const firebaseConfig = {
//     apiKey: "AIzaSyAbOcbg_uREVit_xkp0Gfmqlf_s_5PPJX0",
//     authDomain: "veranocinepolis2023.firebaseapp.com",
//     projectId: "veranocinepolis2023",
//     storageBucket: "veranocinepolis2023.appspot.com",
//     messagingSenderId: "912252292444",
//     appId: "1:912252292444:web:62d2fa26d162a210f58599"
// }
const firebaseConfig = {
    apiKey: "AIzaSyArj7Xc7Ig9yQ9Bnj1drSC7VpuOQJ1nN94",
    authDomain: "cinepolisveranopautacreativa.firebaseapp.com",
    projectId: "cinepolisveranopautacreativa",
    storageBucket: "cinepolisveranopautacreativa.appspot.com",
    messagingSenderId: "824795163982",
    appId: "1:824795163982:web:64c92746b6f071bc49c21f"
};


firebase.initializeApp(firebaseConfig)

// utils
const db = firebase.firestore()
const auth = firebase.auth()
const storage = firebase.storage()
const functions = firebase.functions()

// collection references
const usersCollection = db.collection('users')
const postsCollection = db.collection('posts')
const commentsCollection = db.collection('comments')
const likesCollection = db.collection('likes')
const ticketsCollection = db.collection('tickets')

// export utils/refs
export {
    db,
    auth,
    storage,
    functions,
    usersCollection,
    postsCollection,
    commentsCollection,
    likesCollection,
    ticketsCollection
}